import { onMounted, onUnmounted, ref } from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';

const templateElement = document.getElementById('certificate-template');
export default {
  template: templateElement ? templateElement.innerHTML : '',

  setup() {
    const drawer = ref(null);
    const certifiedColumn = ref([]);

    onMounted(() => {
      EventBus.on('ents:vue:certificate:drawer:open', (column) => {
        certifiedColumn.value = column;
        openCertificateDrawer();
      });
    });

    onUnmounted(() => {
      EventBus.off('ents:vue:certificate:drawer:open', openCertificateDrawer);
    });

    const openCertificateDrawer = () => {
      drawer.value.show();
    };

    return {
      drawer,
      certifiedColumn
    };
  },
};
